<template>
  <div class="third looking-setting">
    <div class="third-formOne adhibition">
      <div class="formOne-btn">
        <div class="btn-left">
          <!-- <span class="left-back-icon" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>-->
          <span class="left-back-content">预登陆页面展示配置</span>
          <!-- <span v-if="IDlist !== ''" class="left-back-content">编辑班级信息</span> -->
        </div>
        <div class="btn-right">
          <el-button @click="Reset()" class="btn-two" type="default">重置</el-button>
          <el-button class="btn-two" type="primary" :disabled="SBDisabled" @click="submitFN()">保存</el-button>
        </div>
      </div>
      <el-form
        ref="formList"
        :model="formList"
        :rules="rules"
        :show-message="false"
        label-width="100px"
        @validate="validateValue"
      >
        <div class="formOne-forms">
          <div class="forms-one" style="margin-top: 57px;">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content palTel">预登陆主题色</span>
              </div>
            </div>
            <div class="one-list myform">
              <el-form-item label="预登陆主题色" prop="prepareLoginBackgroud" class="advance-theme">
                <el-color-picker v-model="formList.prepareLoginBackgroud"></el-color-picker>
                <span
                  style="display:inline-block;vertical-align:top;margin:2px 5px"
                >{{formList.prepareLoginBackgroud}}</span>
                <div style="font-size:10px;color:#aeaeb4">用于预登陆页面按钮等颜色渲染，请勿设置白色及相近颜色，否则会导致文字内容不可见</div>
                <!-- <el-button type="primary" @click="toPreview">预览</el-button> -->
              </el-form-item>
            </div>
          </div>
          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content palTel">顶部配图</span>
              </div>
            </div>
            <div class="one-list myform">
              <!-- :data="{fileType:1}"
                    :limit="1"
                    :on-preview="handlePictureCardPreview_S"
                    :on-remove="handleRemove_S"
                    :on-success="handleSuccess_S"
                    :on-error="hadleError_S"
                    :before-upload="beforeUpload_S"
              :file-list="fileList_S"-->
              <!-- :class="{hide:hideUpload_S}" -->
              <el-form-item label="顶部配图" prop="topDrawingUrl">
                <el-upload
                  class="list-upload-img my-upload"
                  action="/api/blade-platform/platformapplyguiselogo/upload"
                  accept=".jpg, .jpeg, .png, .gif"
                  list-type="picture-card"
                  :file-list="adLandingBackImgList"
                  :on-success="getAdLandingBackImg"
                  :on-remove="removeAdLandingBackImg"
                  :on-error="hadleError"
                  :before-upload="beforeUpload"
                  :on-preview="handlePreview"
                >
                  <i class="el-icon-plus"></i>
                  <div class="list-upload-title" style="font-size:12px">点击上传</div>
                  <div
                    slot="tip"
                    class="list-upload-tip my-upload-footer"
                    style="font-size:10px"
                  >20M以内，支持扩展名.png、.jpg、.jpeg、.gif，建议为1920*300px的矩形图片</div>
                </el-upload>
              </el-form-item>
              <el-form-item label="标语" prop="topDrawingPoster">
                <el-input
                  class="list-input myInput_config"
                  :maxlength="20"
                  v-model.trim="formList.topDrawingPoster"
                  placeholder="请输入20个字以内的标语"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content palTel">搜索</span>
              </div>
            </div>
            <div class="one-list myform">
              <el-form-item label="搜索框提示语" prop="searchPrompt">
                <el-input
                  class="list-input myInput_config"
                  :maxlength="30"
                  v-model.trim="formList.searchPrompt"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content palTel">登录入口</span>
              </div>
            </div>
            <div class="one-list myform">
              <el-form-item label="其他用户登录" prop="otherLoginShow">
                  <el-radio-group v-model="formList.otherLoginShow">
                  <el-radio :label="1">展示</el-radio>
                  <el-radio :label="0">不展示</el-radio>
                  </el-radio-group>
              </el-form-item>
              <el-form-item label="登录名称" prop="otherLoginName" v-if="formList.otherLoginShow==1">
                <el-input
                  class="list-input myInput_config"
                  :maxlength="6"
                  v-model.trim="formList.otherLoginName"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>

            </div>
          </div>
          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content palTel">第三方关注内容</span>
              </div>
            </div>
            <div class="one-list myform">
              <div>
                  <el-button icon="el-icon-plus" @click="openAddDialog" :disabled="currentTableData.length >=9"
                  >添加第三方关注内容</el-button
                >
              </div>
                <div style="margin: 5px 4px" class="showTag">
                    <el-tag
                      style="margin: 0 4px"
                      v-for="tag in currentTableData"
                      :key="tag.id"
                      @close="handleRoleClose(tag)"
                      closable
                      >{{ tag.service_name }}</el-tag
                >
                </div>
            </div>
          </div>
          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content palTel">推荐服务</span>
                 <span style="font-size: 12px;display: inline-block;margin-top: 2px;margin-left: 10px;color: #ff4d4f;">点击推荐栏目不放可拖动顺序</span>
              </div>
            </div>
            <div class="one-list myform ">
              <el-form-item label="推荐栏目" :rules="[{ required: true}]">
                <div class="one-list one-list-three">
                    <div class="list-one-line">
                        <el-form-item
                        v-for="(item, index) in formList.recommendedColumnVOS"
                        style="margin-bottom: 5px;cursor: pointer;"
                        :key="index"
                        >
                        <div style="display:flex" class="showItem">
                            <!-- <el-checkbox
                            :disabled="item.isCustom === 2"
                            v-model="item.isSelect"
                            >{{item.fieldName}}</el-checkbox
                            > -->
                            <span style="font-size:12px;margin:0px 10px 0px 0px">{{item.fieldName}}</span>
                            <el-form-item
                                :prop="'recommendedColumnVOS.' + index + '.value'"
                                :rules="{
                                    required: true,
                                    message: `请输入${item.fieldName}栏目展示名称`,
                                    trigger: 'blur',
                                }">
                                <el-input
                                class="list-input myInput_config"
                                :maxlength="6"
                                v-model.trim="item.value"
                                :placeholder="`请输入${item.fieldName}栏目展示名称`"
                                ></el-input>
                            </el-form-item>
                        </div>
                        </el-form-item>
                    </div>
                </div>
              </el-form-item>
            </div>
          </div>
          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content palTel">服务分类</span>
                 <span style="font-size: 12px;display: inline-block;margin-top: 2px;margin-left: 10px;color: #ff4d4f;">点击具体身份和分类不放可拖动顺序</span>
              </div>
            </div>
            <div class="one-list myform ">
              <el-form-item label="分类方式" prop="classStyle">
                  <el-radio-group v-model="formList.classStyle">
                  <el-radio :label="1">区分用户身份</el-radio>
                  <el-radio :label="0" v-if="false">区分应用和流程</el-radio>
                  </el-radio-group>
              </el-form-item>
              <el-form-item label="展示身份" :rules="[{ required: true}]">
                <div class="one-list one-list-one">
                    <div class="list-one-line">
                        <el-form-item
                        v-for="(item, index) in formList.showIdentityVOS"
                        style="margin-bottom: 5px;cursor: pointer;"
                        :key="index"
                        >
                        <div style="display:flex" class="showItem">
                            <el-checkbox
                            :disabled="item.fieldName === '教工'||item.fieldName === '学生'"
                            v-model="item.isSelect"
                            @change="IsCheckedVisitor(item)"
                            >{{item.fieldName}}</el-checkbox
                            >
                            <el-form-item
                                :prop="'showIdentityVOS.' + index + '.value'"
                                :rules="{
                                    required: item.isSelect?true:false,
                                    message: `请输入${item.fieldName}身份展示名称`,
                                    trigger: 'blur',
                                }">
                                <el-input
                                class="list-input myInput_config"
                                :maxlength="9"
                                v-model.trim="item.value"
                                :placeholder="`请输入${item.fieldName}身份展示名称`"
                                ></el-input>
                            </el-form-item>
                        </div>
                        </el-form-item>
                    </div>
                </div>
              </el-form-item>
              <el-form-item label="展示分类" :rules="[{ required: true}]">
                <div class="one-list one-list-two">
                    <div class="list-one-line">
                        <el-form-item
                        v-for="(item, index) in formList.showTypeVOS"
                        style="margin-bottom: 5px;cursor: pointer;"
                        :key="index"
                        >
                        <div style="display:flex" class="showItem">
                            <!-- <el-checkbox
                            :disabled="item.isCustom === 2"
                            v-model="item.isSelect"
                            >{{item.fieldName}}</el-checkbox
                            > -->
                            <span style="font-size:12px;margin:0px 10px 0px 0px">{{item.fieldName}}</span>
                            <el-form-item
                                :prop="'showTypeVOS.' + index + '.value'"
                                :rules="{
                                    required: true,
                                    message: `请输入${item.fieldName}分类展示名称`,
                                    trigger: 'blur',
                                }">
                                <el-input
                                class="list-input myInput_config"
                                :maxlength="9"
                                v-model.trim="item.value"
                                :placeholder="`请输入${item.fieldName}分类展示名称`"
                                ></el-input>
                            </el-form-item>
                        </div>
                        </el-form-item>
                    </div>
                </div>
              </el-form-item>
            </div>
          </div>
          <div class="forms-one" style="margin-bottom: 50px;">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content palTel">服务数据统计</span>
              </div>
            </div>
            <div class="one-list myform">
              <el-form-item label="统计身份" prop="statisticsIdentity">
                <el-checkbox-group v-model="formList.statisticsIdentity">
                    <el-checkbox label="1" disabled>教工</el-checkbox>
                    <el-checkbox label="2" disabled>学生</el-checkbox>
                    <el-checkbox label="3" :disabled="!isDisable">访客</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <preview-modal
      :previewModal="dialogVisible"
      :previewImageUrl="dialogImageUrl"
      @previewClose="closePreview"
    ></preview-modal>
    <addOfficalAccounts
      :addModalVisible="addModalVisible"
      @closeAddModal="closeAddModal"
      :choosedList="currentTableData"
      @addData="addData"
    ></addOfficalAccounts>
  </div>
</template>

<script>
import {
  detailWG,
  submit
} from "@/store/management/Myconfig"; //我的
import Sortable from "sortablejs";
import addOfficalAccounts from './components/addOfficalAccounts';
import { cloneDeep } from "lodash";
import { setStore, getStore } from "@/utils/store";
export default {
  name: "formSeven",
  props: ["IDlist"],
  components: {
    addOfficalAccounts
  },
  data () {
    return {
      // color: '#FF4D4F',
      rules: {
        otherLoginName: [{ required: true, message: "请输入登录名称", trigger: "blur" },],
        topDrawingUrl: [{ required: true, message: "请选择顶部配图" }],
        // logo: [{ required: true, message: "请选择系统logo" }],
        prepareLoginBackgroud: [{ required: true, message: "请选择预登陆主题色", trigger: "blur"}],
        otherLoginShow: [{required:true, message: "请选择其他用户登录展示", trigger: "blur"}],
        classStyle: [{required:true, message: "请选择分类方式",trigger:"blur"}],
        searchPrompt:[{required:true, message: "请输入搜索框提示语",trigger:"blur"}],
        statisticsIdentity: [{required:true, message: "请选择范围数据统计",trigger:"blur"}],
      },
      formList: {
        id: '',
        //==================================新增配置
        otherLoginName: '', // 登录名称
        otherLoginShow: 1,//其他用户登录
        topDrawingUrl: '', // 顶部配图
        prepareLoginBackgroud: '', // 预登陆主题色
        topDrawingPoster:'',//标语
        webImConfig: 1, // web-im 启用配置
        classStyle: 1, //分类方式
        searchPrompt:'', // 搜索框提示语
        statisticsIdentity:['1','2'],//统计身份
        showIdentityVOS:[
        {
            "fieldName": "教工",
            "orderNumber": "",
            "isSelect": true,
            "value": "",
            "fieldId": "1"
        },{
            "fieldName": "学生",
            "orderNumber": "",
            "isSelect": true,
            "value": "",
            "fieldId": "2"
        },{
            "fieldName": "访客",
            "orderNumber": "",
            "isSelect": "",
            "value": "",
            "fieldId": "3"
        }
        ],
        showTypeVOS:[
        {
            "fieldName": "场景",
            "orderNumber": "",
            "value": "",
            "fieldId": "1"
        },{
            "fieldName": "部门",
            "orderNumber": "",
            "value": "",
            "fieldId": "2"
        },{
            "fieldName": "类型",
            "orderNumber": "",
            "value": "",
            "fieldId": "3"
        }
        ],
        recommendedColumnVOS:[
        {
            "fieldName": "推荐",
            "orderNumber": "",
            "value": "",
            "fieldId": "1"
        },{
            "fieldName": "上新",
            "orderNumber": "",
            "value": "",
            "fieldId": "2"
        },{
            "fieldName": "热门",
            "orderNumber": "",
            "value": "",
            "fieldId": "3"
}
        ]
      },//数据
      fileList: [],//默认配置图
      dialogVisible: false,
      dialogImageUrl: "",
      adLandingBackImgList: [],
      adLandingLogoList: [],
      sysLogo: [],
      countNum: 1,
      //=============================添加第三方关注内容
      addModalVisible: false,
      currentTableData: [],
    //   initTableData:[],
      isDisable:false,
      SBDisabled:false

    }
  },
  created () {
    this.detailWGFN()
  },
  mounted () {
      this.initSortabel()
      this.initSortabelTwo()
      this.initSortabelThree()
       this.initSortLabel()
  },
  computed: {
    // isDisable() {
    //     const findIsDisable= this.formList.showIdentityVOS.find((item)=>{
    //         return item.fieldName=='访客'
    //     })
    //     return findIsDisable.isSelect
    // }
  },
    //   watch: {
    //     isIdentity: {
    //         handler: function(newValue, oldValue) {
    //             //  debugger
    //             console.log(newValue, oldValue)
    //         //do something
    //         },
    //         deep: true
    //     }
    //     },
  methods: {
    //点击访客展示身份时候绑定下方访客多选框
    IsCheckedVisitor(item){
        // console.log(item)
        if (item.fieldName=='访客') {
            this.isDisable=item.isSelect
        }
        if (item.fieldName=='访客' && item.isSelect==false) {
            console.log(item)
            const { statisticsIdentity } = this.formList;
            this.formList.statisticsIdentity = statisticsIdentity.filter((aaa) => {
                return aaa !== "3"
            });
        }
    },
    //删除标签
    handleRoleClose(tag) {
      console.log(tag);
      const { currentTableData } = this;
      this.currentTableData = currentTableData.filter((item) => item !== tag);
    },
    addData (list) {
      console.log(list)
    //   const initTableData = getStore({
    //       name: 'initTableData',
    //       type: "session"
    //     });
    //   console.log(this.initTableData)
    // //   this.currentTableData = uniqBy([...this.currentTableData,...list],'serviceId')
    //   const oldList = initTableData.map((item)=>{
    //     return {
    //         id: item.id,
    //         service_name:item.service_name
    //     }
    // })
    //   const resolveData = []
    //   const temporaryOldList = []
    //   list.forEach((newData, index) => {
    //     const isHaveData = oldList.find(oldData => {
    //       return oldData.serviceId === newData.serviceId
    //     })
    //     if (isHaveData !== undefined) {
    //       console.log('isHaveData', isHaveData)
    //       temporaryOldList.push(isHaveData)
    //     } else {
    //       resolveData.push(newData)
    //     }
    //   })
    const aa = cloneDeep(this.currentTableData)
    const resolveData=list.map((item)=>{
        return {
            id: item.id,
            service_name:item.service_name
        }
    })
    //   resolveData.reverse()
      console.log('添加数据', resolveData)

      this.currentTableData = [...resolveData,...aa]
      this.closeAddModal()
    },
    closeAddModal () {
      this.addModalVisible = false
    },
    openAddDialog () {
      this.addModalVisible = true
    },
    // 行拖拽
    initSortLabel() {
      const el = document.querySelector(".myform .showTag");
      const Vm = this;
      console.log("el", el);
      Vm.sortable = new Sortable(el, {
        animation: 300,
        onEnd(evt) {
          // 拖拽结束发生该事件
          Vm.currentTableData.splice(
            evt.newIndex,
            0,
            Vm.currentTableData.splice(evt.oldIndex, 1)[0]
          );
          const newArray = Vm.currentTableData.slice(0);
          //此处如果不重置为空,那么不会有刺激的动画样式
          Vm.currentTableData = [];
          Vm.$nextTick(() => {
            Vm.currentTableData = newArray;
          });
        }
      });
    },
    // 初始化拖拽
    initSortabel() {
      try {
        const el = document.querySelector(".one-list-one .list-one-line");
        // console.log(el)
        // 阻止火狐默认搜索事件
        el.ondrop = (evt) => {
          evt.stopPropagation();
          evt.preventDefault();
        };
        const Vm = this;
        Vm.sortable = new Sortable(el, {
          animation: 300,
          onEnd(evt) {
            // 拖拽结束发生该事件
            Vm.formList.showIdentityVOS.splice(
              evt.newIndex,
              0,
              Vm.formList.showIdentityVOS.splice(evt.oldIndex, 1)[0]
            );
            const newArray = Vm.formList.showIdentityVOS.slice(0);
            Vm.formList.showIdentityVOS = [];
            console.log(window.scrollY);
            console.log(document.querySelector(".third-formOne").scrollTop)
            // 保存当前滚动高度
            // const scrollTopH = document.querySelector(".third-formOne").scrollTop
            Vm.$nextTick(() => {
              Vm.formList.showIdentityVOS = newArray;
              Vm.sortable = null;
              Vm.$nextTick(() => {
                Vm.initSortabel();
                // document.querySelector(".third-formOne").scrollTop += scrollTopH
              });
              console.log(Vm.formList.showIdentityVOS);
            });

          },
        });
      } catch (error) {
    console.log(error);
      }
    },
    // 初始化拖拽
    initSortabelTwo() {
      try {
        const el = document.querySelector(".one-list-two .list-one-line");
        // console.log(el)
        // 阻止火狐默认搜索事件
        el.ondrop = (evt) => {
          evt.stopPropagation();
          evt.preventDefault();
        };
        const Vm = this;
        Vm.sortable = new Sortable(el, {
          animation: 300,
          onEnd(evt) {
            // 拖拽结束发生该事件
            Vm.formList.showTypeVOS.splice(
              evt.newIndex,
              0,
              Vm.formList.showTypeVOS.splice(evt.oldIndex, 1)[0]
            );
            const newArray = Vm.formList.showTypeVOS.slice(0);
            Vm.formList.showTypeVOS = [];
            console.log(window.scrollY);
            console.log(document.querySelector(".third-formOne").scrollTop)
            // 保存当前滚动高度
            // const scrollTopH = document.querySelector(".third-formOne").scrollTop
            Vm.$nextTick(() => {
              Vm.formList.showTypeVOS = newArray;
              Vm.sortable = null;
              Vm.$nextTick(() => {
                Vm.initSortabelTwo();
                // document.querySelector(".third-formOne").scrollTop += scrollTopH
              });
              console.log(Vm.formList.showTypeVOS);
            });

          },
        });
      } catch (error) {
    console.log(error);
      }
    },
    // 初始化拖拽
    initSortabelThree() {
      try {
        const el = document.querySelector(".one-list-three .list-one-line");
        // console.log(el)
        // 阻止火狐默认搜索事件
        el.ondrop = (evt) => {
          evt.stopPropagation();
          evt.preventDefault();
        };
        const Vm = this;
        Vm.sortable = new Sortable(el, {
          animation: 300,
          onEnd(evt) {
            // 拖拽结束发生该事件
            Vm.formList.recommendedColumnVOS.splice(
              evt.newIndex,
              0,
              Vm.formList.recommendedColumnVOS.splice(evt.oldIndex, 1)[0]
            );
            const newArray = Vm.formList.recommendedColumnVOS.slice(0);
            Vm.formList.recommendedColumnVOS = [];
            console.log(window.scrollY);
            console.log(document.querySelector(".third-formOne").scrollTop)
            // 保存当前滚动高度
            // const scrollTopH = document.querySelector(".third-formOne").scrollTop
            Vm.$nextTick(() => {
              Vm.formList.recommendedColumnVOS = newArray;
              Vm.sortable = null;
              Vm.$nextTick(() => {
                Vm.initSortabelThree();
                // document.querySelector(".third-formOne").scrollTop += scrollTopH
              });
              console.log(Vm.formList.recommendedColumnVOS);
            });

          },
        });
      } catch (error) {
    console.log(error);
      }
    },
    validateValue (prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    toPreview() {
      // this.$router.push({
      //   name: 'previewAdvanceLanding'
      // });
      const strData = JSON.stringify(
        this.formList
      )
      sessionStorage.setItem(
        'formValue',
        strData
      )
      const url = window.location.protocol+'//'+window.location.host + window.location.pathname + '#/previewAdvanceLanding'
      window.open(url)
    },
    removeAdLandingBackImg () {
      this.formList.topDrawingUrl = ''
      this.adLandingBackImgList = []
    },
    // 预登陆背景成功回调函数
    getAdLandingBackImg (response) {
      console.log('result',response)
      if (response.status!=1000) {
         this.$message.error(response.msg)
          this.formList.topDrawingUrl = ''
          this.adLandingBackImgList = []
          return
      }
       this.formList.topDrawingUrl = response.result
       this.adLandingBackImgList=[{name:new Date().getTime(),url:response.result}]
    },
    handleExceed () {
      this.$message.error("一次只能上传一张图片");
    },
    //保存
    submitFN () {
      // console.log(this.formList.showIdentityVOS)
      // return
      this.countNum = 0;
      this.$nextTick(() => {
        this.$refs.formList.validate(valid => {
          if (valid) {
            try {
              this.countNum = 1
              this.SBDisabled=true
              this.goSubmit()
            } catch (err) {
              this.countNum = 1;
              console.log(err)
            }
          } else {
            return false;
          }
        });
      });
    },
    async goSubmit(){
        try {
            if (this.currentTableData.length>9) {
                this.SBDisabled=false
                return this.$message.error("第三方关注内容不能超过九个")
            }
            const arr=[]
            if (this.currentTableData.length) {
                this.currentTableData.forEach((item)=>{
                    arr.push(item.id)
                })
            }
            let {
            data: { status, msg, result },
            } = await this.$store.dispatch("platformPreLoginPageShoConfigSubmit",{
                "searchPrompt": this.formList.searchPrompt,
                "showTypeVOS":  this.formList.showTypeVOS,
                "otherLoginShow": this.formList.otherLoginShow,
                "showIdentityVOS": this.formList.showIdentityVOS,
                "recommendedColumnVOS": this.formList.recommendedColumnVOS,
                "prepareLoginBackgroud": this.formList.prepareLoginBackgroud,
                "topDrawingUrl": this.formList.topDrawingUrl,
                "statisticsIdentity": this.formList.statisticsIdentity.join(','),
                "id": this.formList.id,
                "otherLoginName": this.formList.otherLoginName,
                topDrawingPoster: this.formList.topDrawingPoster,
                "thirdPartyConcerns": arr.join(','),
            });
            if (status === 1000) {
                console.log(result)
                this.$message.success(msg)
                // this.Reset()
                this.SBDisabled=false
                this.Reset()
            } else {
                this.$message({
                    type: "error",
                    message: msg,
                });
                this.SBDisabled=false
            }
        } catch (err) {
            console.log(err);
            this.SBDisabled=false
        }
    },
    //重置
    Reset () {
      this.$refs.formList.clearValidate()
      this.fileList = []
      this.adLandingBackImgList = []
      this.sysLogo = []
      this.adLandingLogoList = []
      this.currentTableData=[]
      setStore({
            name: 'initTableData',
            content: [],
            type: "session"
        });
      this.detailWGFN()
    },
    //获取数据
    async detailWGFN () {
      try {
        const list= await this.$store.dispatch("serviceInfoGetAllServerDict");
        const aaa=list.data.result.map((item)=>{
            return{
                id: item.id,
                service_name:item.service_name
            }
        })
        console.log(aaa);
        let {
          data: { status, msg, result },
        } = await this.$store.dispatch("platformPreLoginPageShoConfigDetail");
        if (status === 1000) {
            console.log(result)
            const obj = cloneDeep(result.showIdentityVOS)
            let aa = obj.find((item)=>{
                return item.fieldName = '访客'
            })
            if (aa && aa.isSelect == true) {
                // debugger
                this.isDisable=true
                // debugger
            }
            const ids = result.thirdPartyConcerns
            if (ids) {
                const arr=ids.split(',')
                let initTableData=[]
                arr.forEach(element => {
                    aaa.forEach((item)=>{
                        if (element === item.id) {
                            this.currentTableData.push(item)
                            initTableData.push(item)
                        }
                    })
                });
                // const initTableData1 = initTableData.map((item)=>{
                //     return {
                //         id: item.id,
                //         service_name:item.service_name
                //     }
                // })
                setStore({
                    name: 'initTableData',
                    content: initTableData,
                    type: "session"
                });
            } else {
                this.currentTableData=[]
            }
            // return
            this.formList.searchPrompt = result.searchPrompt,
            this.formList.showTypeVOS = result.showTypeVOS,
            this.formList.otherLoginShow = result.otherLoginShow,
            this.formList.showIdentityVOS = result.showIdentityVOS,
            this.formList.recommendedColumnVOS = result.recommendedColumnVOS,
            this.formList.prepareLoginBackgroud = result.prepareLoginBackgroud,
            this.formList.topDrawingPoster = result.topDrawingPoster,
            this.formList.topDrawingUrl = result.topDrawingUrl
            if ( result.topDrawingUrl ) {
                this.adLandingBackImgList.push({name:new Date().getTime(),url:result.topDrawingUrl});
            }
            this.formList.statisticsIdentity = result.statisticsIdentity.split(','),
            this.formList.id = result.id,
            this.formList.otherLoginName = result.otherLoginName
        } else {
          this.$message({
            type: "error",
            message: msg,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    //上传之前
    beforeUpload (file) {
      const isJPG = ["image/png", "image/jpg", "image/jpeg"].indexOf(file.type);

      if (isJPG == -1) {
        this.$message.error("上传配图只能是png jpg jpeg图片格式!");
        return false;
      }

      const imgsize = file.size / 1024 / 1024 <= 20;
      if (!imgsize) {
        this.$message.error("上传图片最大20M, 请重新上传!");
        return false;
      }
    },
    //成功
    handleSuccess (file) {
      // console.log(file)
      this.formList.logo = file.result
    },
    //点击
    handlePreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //失败
    hadleError (err) {
      this.$message.error(err)
    },
    //移除
    handleRemove (file, fileList) {
      this.formList.logo = ""
      console.log("移除")
    },
    //关闭弹框
    closePreview () {
      this.dialogVisible = false
    },
  }
};
</script>

<style lang="scss">
.looking-setting {
  .phon-right {
    position: relative;
    // border:1px solid red;
    width: 40%;
    display: inline-block;
    // height:calc(100vh - 102px);
    height: 100%;
    border-left: 1px solid #dcdee2;
    img {
      // border: 1px solid red;
      width: 389px;
      height: 669px;
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
  .advance-theme{
    .el-button{
      margin-left: 0!important;
    }
  }
  .myform {
    .el-form-item__label {
      padding-right: 10px;
    }
  }
  .myInput_config {
    width: 298px !important;
  }
  .palTel {
    font-size: 14px !important;
  }
  .my-upload {
    height: 115px;
    position: relative;
    .el-upload--picture-card {
      width: 80px !important;
      height: 80px !important;
      line-height: 80px !important;
      float: left;
      overflow: hidden;
    }
    .el-upload-list__item {
      width: 204px !important;
      height: 80px !important;
      margin-left: 14px !important;
    }
    .my-upload-footer {
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
}
</style>
